import React, { useState,useEffect,useContext,Suspense,lazy } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,ColumDataTableReorganize,FormatedPrice,ExportArticleButton,AddMarkExportForm,useLocalStorage,ModalFactureVision,BtnAcquitteFacture,Loading,constructionDocument,InputSearchClient} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import Moment from 'react-moment';
import { IsAuthContext } from 'app/App';
import { Modal } from "react-bootstrap";
import { documentFormatter,cellStyleEtat,cellStyleEtatConversion,rowStyle } from "app/views/facturation/datatable_facture_tools";
import {Link} from 'react-router-dom'
import overlayFactory from 'react-bootstrap-table2-overlay';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import PennylaneFactureBtn from '../buttons/PennylaneFactureBtn';
const PaymentAddForm = lazy(() => import('app/views/facturation/CreateComp/EndComp/Comp/PaymentAddForm'));
const BulkPaymentAddForm = lazy(() => import('app/views/facturation/CreateComp/EndComp/Comp/BulkPaymentAddForm'));
const SendBulkEmailForm = lazy(() => import('@gull/components/form/SendBulkEmailForm'));
const PennylaneFactureBulkRequestForm = lazy(() => import('@gull/components/Facturation/PennylaneFactureBulkRequestForm'));

const isEligibleForBulkSettle = (value) => value.type=='billing' && value.etat!='acquitte' && +value.ttc > value.facture_paiement_records.reduce((sum, r) => sum + +r.montant, 0)
const isPennylaneCovered = (value) => (value.type=='billing' || value.type=='creditNote') && !value.cancelled && value.bar!=null

const CustomDataTable = (props) => {
    const t = useTranslate();
    const isLoading = (props.loadingTable || props.loading) ? true : false;

    useEffect(() => {
        //isLoading et columnOrganize sont ajoutés aux dépendances car le wrapper de react-loading-overlay (utilisé pour l'overlay de chargement) et columnOrganize (régénéré à chaque rechargement des données, cf. useEffect sur allRowsOnPageSelected dans SearchDataTable) sortent le tableau de son conteneur de scroll à chaque re-render : il faut donc le réenvelopper systématiquement après
        scrollXDataTable(window.screen.width,props.columns.length)
        //react-loading-overlay retire son spinner du DOM avec un fondu de 500ms (fadeSpeed par défaut) après la fin du chargement, ce qui perturbe à nouveau le positionnement du tableau une fois ce délai passé : on réapplique donc une seconde fois après ce délai
        const timeout = setTimeout(() => scrollXDataTable(window.screen.width,props.columns.length), 600);
        return () => clearTimeout(timeout);
    }, [window.screen.width,props.columns.length,props.columnOrganize,isLoading]);

    const loadingOverlay = overlayFactory({
        spinner: true,
        text: t('cours_chargement')+'...',
    });

    const defaultSorted = [{
        dataField: 'date',
        order: 'desc'
    }];

    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            rowStyle={ props.rowStyle }
            onTableChange={ props.handleTableChange }
            defaultSorted={defaultSorted}
            hover
            condensed
            responsive
            overlay={loadingOverlay}
            loading={isLoading}
        />
    );
};

const SearchDataTable = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const cookieName = props.cookieName || 'search_billing_table_reorganize';
    const paginationApiUrlPrefix = props.paginationApiUrlPrefix || 'api/facture/invoice/get_all/';
    const exportUrls = props.exportUrls || {
        documents: 'api/facture/invoice/export_factures',
        sales: 'api/facture/invoice/export_sales',
        payments: 'api/facture/invoice/export_paiements',
    };
    const [addMark,setAddMark]=useState(true)
    const [cookies, setCookie] = useCookies([cookieName]);
    const [localStorage, setLocalStorage] = useLocalStorage([cookieName]);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage[cookieName] && cookies[cookieName]){
            setLocalStorage(cookieName, cookies[cookieName]);
        }
    }, []);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [textModal,setTextModal]=useState(false) 
    const [lang, setLang] = useCookies(['lang']);
    const [loading,setLoading] = useState(false)
    const [documentModal,setDocumentModal]=useState(false)
    const [selectedDocumentId,setSelectedDocumentId]=useState(false)
    const [titleDocument,setTitleDocument]=useState(false)
    const [brownDocumentModal,setBrownDocumentModal]=useState(false)
    const [showPaymentForm,setShowPaymentForm]=useState(false)
    const [showModalPaymentForm,setShowModalPaymentForm]=useState(false)
    const [validButtonPayment,setValidButtonPayment]=useState(false)
    const [errorsPayment,setErrorsPayment]=useState(false)
    const [selectedRow,setSelectedRow]=useState([])//liste des factures (objet complet) sélectionnées pour l'acquittement en masse
    const [showBulkPaymentModal,setShowBulkPaymentModal]=useState(false)
    const [showBulkEmailModal,setShowBulkEmailModal]=useState(false)
    const [showBulkPennylaneModal,setShowBulkPennylaneModal]=useState(false)

    const moduleInvoice = authParam.modules.find(value=>value.name=='invoice')
    // Aucune fonctionnalité Pennylane tant que l'option n'est pas activée sur la company
    const pennylaneActive = authParam.modules.find(value=>value.name=='admin')?.params?.pennylane?.active

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    let devise = authParam.company.devise;
    let digit = (authParam.company.advanceparams.hasOwnProperty('ventilation_espece') && authParam.company.advanceparams.ventilation_espece.piece.find(piece=> +piece < 1)) ? 2 : 0;
    var maxCarac = 15;

    const handleDocumentModal = (id,bar,type) => {
        setSelectedDocumentId(id)
        setTitleDocument({
            bar:bar,
            type:type
        })
        setDocumentModal(true)
    }

    const allRowsOnPageSelected = props.allDocuments.length!=0 && props.allDocuments.every(value=>selectedRow.some(selected=>selected.id==value.id))
    const allSelectedEligibleForSettle = selectedRow.length!=0 && selectedRow.every(value=>isEligibleForBulkSettle(value))

    const selectRow = (name,value) => {
        if(name=='all'){
            setSelectedRow(current => {
                const pageIsFullySelected = props.allDocuments.length!=0 && props.allDocuments.every(row=>current.some(selected=>selected.id==row.id))
                if(pageIsFullySelected){
                    //toutes les lignes de la page sont cochées : on les décoche
                    return current.filter(selected=>!props.allDocuments.some(row=>row.id==selected.id))
                }
                //on ajoute les lignes de la page qui ne sont pas déjà cochées
                let newRows = props.allDocuments.filter(row=>!current.some(selected=>selected.id==row.id))
                return [...current,...newRows]
            })
        }else{
            setSelectedRow(current => current.some(selected=>selected.id==value.id)
                ? current.filter(selected=>selected.id!=value.id)
                : [...current,value]
            )
        }
    }

    const closeBulkPaymentModal = (hasReloaded) => {
        setShowBulkPaymentModal(false)
        if(hasReloaded){
            setSelectedRow([])
            props.setReload(Date.now())
        }
    }

    const closeBulkEmailModal = (hasSent) => {
        setShowBulkEmailModal(false)
        if(hasSent){
            setSelectedRow([])
            props.setReload(Date.now())
        }
    }

    const closeBulkPennylaneModal = (hasSent) => {
        setShowBulkPennylaneModal(false)
        if(hasSent){
            setSelectedRow([])
            props.setReload(Date.now())
        }
    }

    let dataTable = new Array
    props.allDocuments.length!=0 && props.allDocuments.map((value,ind)=>{
        let finalise=((value.type!='quotation' && value.type!='creditNote' && value.type!='billingDeposit') && value.date_validation && !value.cancelled) ? true : false;

        let tos = (Object.keys(value.tos).length!=0) ? true : false
        let pos = (Object.keys(value.pos).length!=0) ? true : false

        //gestion des états
        let etat1='-';
        let etat2='-';

        if(value.cancelled){//si le documment est annulé, on met tout en annulé
                etat1=t('canceled')
                etat2=t('canceled')
        }
        else{//sinon status indépendant
            if(value.type=='quotation'){
                etat1=(value.etat=='expired') ? t('expired') : t('notExpired')
                etat2=(value.etat_conversion=='notConverted') ? t('notConverted') : t('converted')
            }
            if(value.type=='billingDeposit'){
                switch (value.etat) {
                    case 'unUsed':
                        etat1=t('unUsed')
                        break;
                    case 'partiallyUsed':
                        etat1=t('partiallyUsed')
                        break;
                    case 'used':
                        etat1=t('used')
                        break;
                    default:
                        break;
                }
            }
            if(value.type=='purchaseOrderB2b'){
                switch (value.etat) {
                    case 'collected':
                        etat1=t('collected')
                        break;
                    case 'collectInProgress':
                        etat1=t('collectInProgress')
                        break;
                    case 'notCollected':
                        etat1=t('notCollected')
                        break;
                    default:
                        break;
                }
                switch (value.etat_conversion) {
                    case 'converted':
                        etat2=t('converted')
                        break;
                    case 'partiallyConverted':
                        etat2=t('partiallyConverted')
                        break;
                    case 'notConverted':
                        etat2=t('notConverted')
                        break;
                    default:
                        break;
                }
            }
            if(value.type=='deliveryNote'){
                switch (value.etat) {
                    case 'delivered':
                        etat1=t('delivered2')
                        break;
                    case 'notDelivered':
                        etat1=t('notDelivered2')
                        break;
                    default:
                        break;
                }
                switch (value.etat_conversion) {
                    case 'converted':
                        etat2=t('isFactured')
                        break;
                    case 'notConverted':
                        etat2=t('isNotFactured')
                        break;
                    default:
                        break;
                }
            }
            if(value.type=='billing' || value.type=='billingBuy'){
                switch (value.etat) {
                    case 'notAcquitte':
                        etat1=t('notAcquitte')
                        break;
                    case 'partiallyAcquitte':
                        etat1=t('partiallyAcquitte')
                        break;
                    case 'acquitte':
                        etat1=t('acquitte')
                        break;
                    default:
                        break;
                }
            }
            if(value.type=='creditNote'){
                switch (value.etat) {
                    case 'unUsed':
                        etat1=t('unUsed')
                        break;
                    case 'partiallyUsed':
                        etat1=t('partiallyUsed')
                        break;
                    case 'used':
                        etat1=t('used')
                        break;
                    default:
                        break;
                }
                switch (value.etat_conversion) {
                    case 'converted':
                        etat2=t('converted')
                        break;
                    case 'partiallyConverted':
                        etat2=t('partiallyConverted')
                        break;
                    case 'notConverted':
                        etat2=t('notConverted')
                        break;
                    default:
                        break;
                }
            }
            if(value.type=='creditNoteBuy'){
                switch (value.etat) {
                    case 'unUsed':
                        etat1=t('unUsed')
                        break;
                    case 'partiallyUsed':
                        etat1=t('partiallyUsed')
                        break;
                    case 'used':
                        etat1=t('used')
                        break;
                    default:
                        break;
                }
            }
            if(value.type=='returnNote'){
                switch (value.etat) {
                    case 'collected':
                        etat1=t('collected')
                        break;
                    case 'collectInProgress':
                        etat1=t('collectInProgress')
                        break;
                    case 'notCollected':
                        etat1=t('notCollected')
                        break;
                    default:
                        break;
                }
            }
        }
        //end
        
        let refacturation = (value.type=='purchaseOrderB2b') ? ((Object.keys(value.refacturation).length!=0) ? true : false) : false
        if (Array.isArray(value.refacturation)) refacturation=true

        let facture = (refacturation) ? value.refacturation.find(elem => elem.type=='billing') : false
        let facture_achat = (refacturation) ? value.refacturation.find(elem => elem.type=='billingBuy') : false

        let url_facture = (!facture) ? false : ((facture.bar!=null) ? '/invoice/details/'+facture.id : '/invoice/document/create-add-items/'+facture.id)
        let url_facture_achat = (!facture_achat) ? false : ((facture_achat.bar!=null) ? '/invoice/details/'+facture_achat.id : '/invoice/document/create-add-items/'+facture_achat.id)

        let refacturation_text = (facture || facture_achat) ? 
            ((moduleInvoice!=undefined) ? 
                <>{(facture)?<Link className='list-group lien-to' to={url_facture}>{facture.bar??t('draft')}</Link>:<span></span>}/{(facture_achat)?<Link className='list-group lien-to' to={url_facture_achat}>{facture_achat.bar??t('draft')}</Link>:<span></span>}</> 
            : 
                <>{(facture)?facture.bar??t('draft'):<span></span>}/{(facture_achat)?facture_achat.bar??t('draft'):<span></span>}</>) 
        : 
            t('no')

        let client_str=(value.client_infos.firstname) ? value.client_infos.name+' '+value.client_infos.firstname : value.client_infos.name

        let obj = {
            type: t(value.type),
            bar: value.bar,
            date: value.date_finalisation,
            status: value.type,
            etat: etat1,
            etat_conversion:etat2,
            cancelled: value.cancelled,
            client: <Link to={"/invoice/client/detail/"+value.client_id} className="w-40 w-sm-100">{client_str}</Link>,
            amount: <FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={value.ttc} />,
            id: value.id,
            company: value.other_company!=null ? value.other_company.name : authParam.company.name,
            fournisseur: value.fournisseur!=null ? value.fournisseur.name : '',
            superieur: (value.divers_infos!=null && value.divers_infos.superieur_infos!=null && value.divers_infos.superieur_infos.length>maxCarac) ? <span>{value.divers_infos.superieur_infos.replace( /(<([^>]+)>)/ig, '').substring(0,maxCarac)}<span className='lien-to' onClick={()=>setTextModal(value.divers_infos.superieur_infos.replace( /(<([^>]+)>)/ig, ''))}>...</span></span> : (value.divers_infos!=null && value.divers_infos.superieur_infos!=null) ?value.divers_infos.superieur_infos.replace( /(<([^>]+)>)/ig, '') : '', 

            inferieur: (value.divers_infos!=null && value.divers_infos.inferieur_infos!=null && value.divers_infos.inferieur_infos.length>maxCarac) ? <span>{value.divers_infos.inferieur_infos.replace( /(<([^>]+)>)/ig, '').substring(0,maxCarac)}<span className='lien-to' onClick={()=>setTextModal(value.divers_infos.inferieur_infos.replace( /(<([^>]+)>)/ig, ''))}>...</span></span> : (value.divers_infos!=null && value.divers_infos.inferieur_infos!=null) ? value.divers_infos.inferieur_infos.replace( /(<([^>]+)>)/ig, '') : '', 
            finalise:finalise,
            refacturation: ((tos)?t('fromTo'):(pos)?t('fromPo'):(refacturation)?refacturation_text:''),
            mail_sent: (value.mail_sent)?t('yes'):t('no'),
            mail_opened: (value.mail_opened)?t('yes'):t('no'),
            action:
                <span className="d-flex justify-content-between align-items-center">
                    <input type="checkbox" checked={selectedRow.some(selected=>selected.id==value.id)} onChange={()=>selectRow('one',value)} />
                    <FontAwesomeIcon onClick={() => handleDocumentModal(value.id,value.bar,value.type)} style={{cursor:'Pointer', color:'#FF8919'}} icon={faEye} />
                    {pennylaneActive && isPennylaneCovered(value) &&
                        <PennylaneFactureBtn factureId={value.id} factureBar={value.bar} status={value.pennylane_transmission?.status} index={ind} onChanged={() => props.setReload(Date.now())} />
                    }
                    {isEligibleForBulkSettle(value) &&
                        <BtnAcquitteFacture setShowPaymentForm={setShowPaymentForm} allInfos={value} setShowModalPaymentForm={setShowModalPaymentForm}/>
                    }
                </span>,
            index: ind + 1,
        }
        dataTable.push(obj)
    })

    let columns = [
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
            //ce headerFormatter est figé dans columnOrganize après le montage : il est rafraîchi explicitement par le useEffect ci-dessous (dépendant de allRowsOnPageSelected/props.allDocuments/selectedRow)
            headerFormatter: (column) => (
                <span className="d-flex justify-content-between align-items-center">
                    {props.allDocuments.length!=0 &&
                        <input type="checkbox" checked={allRowsOnPageSelected} onChange={()=>selectRow('all')} />
                    }
                    <span>{column.text}</span>
                </span>
            ),
        },
        {
            dataField: "type",
            text: t('document'),
            editable:false,
            sort:false,
            formatter: documentFormatter(t),
        },
        {
            dataField: "bar",
            text: t('referencePo'),
            editable:false,
            sort:false,
        },
        {
            dataField: "company",
            text: t('company'),
            editable:false,
            sort:false,
        },
        {
            dataField: "fournisseur",
            text: t('administrationFournisseurForm'),
            editable:false,
            sort:false,
        },
        {
            dataField: "date",
            text: 'Date',
            editable:false,
            sort:true,
            formatter: (cell) => <Moment format="DD/MM/YYYY">{cell}</Moment>,
            sortValue: (cell) => new Date(cell).getTime()
        },
        {
            dataField: "etat",
            text: t('etat1'),
            editable:false,
            sort:false,
            style: cellStyleEtat(t),
        },
        {
            dataField: "etat_conversion",
            text: t('etat2'),
            editable:false,
            sort:false,
            style: cellStyleEtatConversion(t),
        },
        {
            dataField: "client",
            text: t('customer'),
            editable:false,
            sort:true,
        },
        {
            dataField: "amount",
            text: t('amountTtc'),
            editable:false,
            sort:false,
        },
        {
            dataField: "superieur",
            text: t('topText'),
            editable:false,
            sort:false,
        },
        {
            dataField: "inferieur",
            text: t('bottomText'),
            editable:false,
            sort:false,
        },
        {
            dataField: "refacturation",
            text: t('refacturation'),
            editable:false,
            sort:false,
        },
        {
            dataField: "mail_sent",
            text: t('mailSent'),
            editable:false,
            sort:false,
        },
        {
            dataField: "mail_opened",
            text: t('mailOpened'),
            editable:false,
            sort:false,
        },
    ];

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage[cookieName]){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage[cookieName].split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage(cookieName, arr.join(), { path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    useEffect(function () {
        //columnOrganize n'est reconstruit qu'au montage (effet ci-dessus à dépendances vides) : sans ce useEffect, le headerFormatter de la case "tout sélectionner" resterait figé sur son état au chargement (donc sans les factures, la liste étant vide à ce moment là)
        //ne PAS ajouter selectedRow ici : allRowsOnPageSelected en dérive déjà et capture tout ce dont ce headerFormatter a besoin (checked de la case "tout sélectionner"). L'ajouter refait tourner ce useEffect à chaque coche individuelle (même quand allRowsOnPageSelected ne change pas), ce qui régénère columnOrganize -> réenveloppement DOM du tableau par scrollXDataTable (cf. useEffect de CustomDataTable ci-dessus) -> la page saute en haut du tableau à chaque clic sur une case.
        setColumnOrganize(prevColumnOrganize => prevColumnOrganize.map(column =>
            column.dataField=='action'
                ? {...column, headerFormatter: (col) => (
                    <span className="d-flex justify-content-between align-items-center">
                        {props.allDocuments.length!=0 &&
                            <input type="checkbox" checked={allRowsOnPageSelected} onChange={()=>selectRow('all')} />
                        }
                        <span>{col.text}</span>
                    </span>
                )}
                : column
        ))
    }, [allRowsOnPageSelected,props.allDocuments])

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                props.setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: props.perPage,
        showTotal: true,
        totalSize: props.sizeDatas,
        page:props.currentPage
    };

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder  }) => {
        if(props.reload){
             props.setPerPage(sizePerPage)

            let params = {//on ajoute le tri (colonne + sens)
                ...props.exportParam,
                sort: sortOrder,
                sortField: sortField
            }
            //on persiste le tri dans exportParam (côté parent) pour qu'il soit conservé lors des rechargements déclenchés hors du tableau (ex: fermeture d'une modal de paiement/visualisation, qui appelle setReload)
            if(props.setExportParam) props.setExportParam(params)
            setLoading(true);
            const response = await axios.post(process.env.REACT_APP_API_URL+paginationApiUrlPrefix+sizePerPage+"/"+page, params
            ).then((response) => {
                props.setAllDocuments(response.data.datas)
                props.setSizeDatas(response.data.count)
                props.setCurrentPage(page)
                setLoading(false)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
                setLoading(false)
            })
        }
    }

    const closeDocumentModal = () => {
        setDocumentModal(false)
        props.setReload(Date.now())
    }

    const callBackConstruct = (response) => {
        setShowPaymentForm(response)
        props.setReload(Date.now())
    };

    const editPlusFacture = async (obj) =>{        
        let data = {}

        Object.entries(obj).map(([key,value])=>{
            if(key!='close') data[key]=value
        })
        constructionDocument(setValidButtonPayment,showPaymentForm.id,callBackConstruct,t,data,false,false)

        if(obj.hasOwnProperty('close')){
            //Si close est passé dans obj, on ferme la modal 
            setTimeout(() => {
                setShowPaymentForm(false)
                setShowModalPaymentForm(false)
            }, 1000);
        }
    }

    const handleCloseModal = () => {
        setShowPaymentForm(false)
        setShowModalPaymentForm(false)
    }
    
    return (
        <div>
            <Modal size="lg" show={showModalPaymentForm} onHide={()=>handleCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('payment')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(showPaymentForm) ? 
                        <Suspense fallback={<Loading></Loading>} >
                            <PaymentAddForm  
                                errors={errorsPayment} 
                                setErrors={setErrorsPayment} 
                                validButton={validButtonPayment} 
                                setValidButton={setValidButtonPayment} 
                                edit={true} 
                                editPlusFacture={editPlusFacture} 
                                allInfos={showPaymentForm}
                                company={authParam.company}
                            />
                        </Suspense>
                    :
                        false
                    }
                </Modal.Body>
            </Modal>
            <Modal size="lg" show={showBulkPaymentModal} onHide={()=>closeBulkPaymentModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('bulkSettle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showBulkPaymentModal &&
                        <Suspense fallback={<Loading></Loading>} >
                            <BulkPaymentAddForm
                                selectedInvoices={selectedRow}
                                company={authParam.company}
                                onClose={closeBulkPaymentModal}
                            />
                        </Suspense>
                    }
                </Modal.Body>
            </Modal>
            <Modal size="lg" show={showBulkEmailModal} onHide={()=>closeBulkEmailModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('bulkSendEmail')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showBulkEmailModal &&
                        <Suspense fallback={<Loading></Loading>} >
                            <SendBulkEmailForm
                                selectedDocuments={selectedRow}
                                onClose={closeBulkEmailModal}
                            />
                        </Suspense>
                    }
                </Modal.Body>
            </Modal>
            <Modal size="lg" show={showBulkPennylaneModal} onHide={()=>closeBulkPennylaneModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('pennylaneBulkSend')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showBulkPennylaneModal &&
                        <Suspense fallback={<Loading></Loading>} >
                            <PennylaneFactureBulkRequestForm
                                selectedInvoices={selectedRow.filter(isPennylaneCovered)}
                                onClose={closeBulkPennylaneModal}
                            />
                        </Suspense>
                    }
                </Modal.Body>
            </Modal>
            <ModalFactureVision
                brownDocumentModal={brownDocumentModal}
                documentModal={documentModal}
                closeDocumentModal={closeDocumentModal}
                titleDocument={titleDocument}
                selectedDocumentId={selectedDocumentId}
                setSelectedDocumentId={setSelectedDocumentId}
                setTitleDocument={setTitleDocument}
                setBrownDocumentModal={setBrownDocumentModal}
            />
            <Modal show={textModal} onHide={() => setTextModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        {textModal}
                    </div>
                </Modal.Body>
            </Modal>
            <CardPerso header={props.header}>
                {columnOrganize.length!=0 &&
                    <small>
                        <ToolkitProvider
                            keyField="index"
                            data={dataTable}
                            columns={columnOrganize}
                        >
                        {(propst) => (
                            <>
                                <div className="row">
                                    <div className="col-12 mb-2">
                                        <div className="row">
                                            <div className="col-8">
                                                <div className="d-flex align-items-baseline mb-3">
                                                    <ColumDataTableReorganize
                                                        columnOrganize={columnOrganize}
                                                        setColumnOrganize={setColumnOrganize}
                                                        setCookie={setLocalStorage}
                                                        cookieName={cookieName}
                                                        showColumnOrganize={showColumnOrganize}
                                                        setShowColumnOrganize={setShowColumnOrganize}
                                                        btnSwitch={false}//pour affiche ou non le btn swith
                                                        initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                                    />&nbsp;&nbsp;&nbsp;
                                                    <span className='d-flex'>
                                                        <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.exportParam} header={[]} title={t('downloadCSVThisDocumentsSelection')} type="button" url={exportUrls.documents}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                                        <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.exportParam} header='all' title={t('downloadCSVThisSalesSelection')} type="button" url={exportUrls.sales}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                                        <ExportArticleButton lang={lang.lang} addMark={addMark} filtre={props.exportParam} header={[]} title={t('downloadCSVThisPaiementSelection')} type="button" url={exportUrls.payments}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                                        <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />
                                                    </span>
                                                </div>
                                            </div>
                                             {(props.clientSearch) &&
                                                <div className="col-4">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <InputSearchClient 
                                                                setClient={props.setClientId}
                                                                disabled={false}
                                                                from='facturation'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {selectedRow.length!=0 &&
                                        <div className="col-12 mb-2 d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                {allSelectedEligibleForSettle &&
                                                    <button className='btn btn-primary btn-sm' onClick={()=>setShowBulkPaymentModal(true)}>
                                                        {t('bulkSettle')}
                                                    </button>
                                                }
                                                <button className='btn btn-outline-primary btn-sm ms-2' onClick={()=>setShowBulkEmailModal(true)}>
                                                    {t('bulkSendEmail')}
                                                </button>
                                                {pennylaneActive && selectedRow.some(isPennylaneCovered) &&
                                                    <button className='btn btn-outline-primary btn-sm ms-2' onClick={()=>setShowBulkPennylaneModal(true)}>
                                                        {t('pennylaneBulkSend')}
                                                    </button>
                                                }
                                            </div>
                                            <div style={{fontSize:'1.1em'}}>
                                                <div>
                                                    {t('bulkSettleSelectedCount')+' : '}
                                                    <span className='fw-bold'>{selectedRow.length}</span>
                                                </div>
                                                {/* toujours monté (visibility, pas de rendu conditionnel) pour que la barre d'actions garde une hauteur stable et ne fasse pas remonter le tableau lorsque l'acquittement en masse n'est plus proposé */}
                                                <div style={{visibility: allSelectedEligibleForSettle ? 'visible' : 'hidden'}}>
                                                    {t('amount')+' : '}
                                                    <span className='fw-bold'>
                                                        <FormatedPrice langRegion={'fr-FR'} devise={devise} digit={digit} priceToFormat={selectedRow.reduce((sum,value)=>sum+(+value.ttc-value.facture_paiement_records.reduce((s,r)=>s+ +r.montant,0)),0)} />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="position-relative">
                                    <CustomDataTable
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        handleTableChange={handleTableChange}
                                        rowStyle={rowStyle(t)}
                                        columns={columns}
                                        columnOrganize={columnOrganize}
                                        loading={loading}
                                        loadingTable={props.loadingTable}
                                    />
                                </div>
                            </>
                        )}
                        </ToolkitProvider>
                    </small>
                }
            </CardPerso>
        </div>
    )
};

export default SearchDataTable;